module.exports = __webpack_public_path__ + "src/assets/img/pic (2).d186a23d.jpg";